import { RoleType, User } from "../Users";

const NONE_VALUE = "__NONE__";

export function filterUsersByRoles<T extends RoleType>(
  users: User<T>[],
  selectedRoles: T[]
): User<T>[] {
  if (selectedRoles.length === 0) {
    return users;
  }

  const includeNone = selectedRoles.includes(NONE_VALUE as T);
  const actualRoles = selectedRoles.filter(r => r !== (NONE_VALUE as T));

  return users.filter(user => {
    const hasNoRoles = !user.roles || user.roles.length === 0;
    if (hasNoRoles) return includeNone;
    return actualRoles.some(role => user.roles.includes(role));
  });
}

export function isRoleFilterActive<T extends RoleType>(
  selectedRoles: T[],
  existingRoles: T[]
): boolean {
  const allRolesCount = existingRoles.length + 1;
  return selectedRoles.length > 0 && selectedRoles.length < allRolesCount;
}
